import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DualAuthService } from '../../services/DualAuthService';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from '@angular/material/icon';
import { CoinWidgetComponent } from "../coin-widget/coin-widget.component";
import { AuthSelectionComponent } from "../auth-selection.component/auth-selection.component";
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import UserService from '../../services/UserService';
import { PageHeaderComponent } from "../page-header/page-header.component";

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-landing-page',
  imports: [CommonModule, MatButtonModule, MatGridListModule, MatIconModule, CoinWidgetComponent, AuthSelectionComponent, PageHeaderComponent],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.css',
})
export class LandingPageComponent implements OnInit {
  loggedIn$: Observable<boolean>;

  constructor(private dualAuthService: DualAuthService, private router: Router, private userService: UserService) {
    this.loggedIn$ = this.dualAuthService.isAuthenticated$;
  }

  ngOnInit(): void {
    this.userService.getMe();
    if(this.dualAuthService.isEmployee() && this.dualAuthService.isAuthenticated()) {
      this.dualAuthService.currentUser$.subscribe(user => {
        user?.roles && user.roles.includes('Administrator') ? this.router.navigate(['/admin']) : this.router.navigate(['/employee']);
      });
    }
    else if(!this.dualAuthService.isAuthenticated())
      this.router.navigate(['/login']);
  }

  goToTransactions(): void {
    this.router.navigate(['/coin-transactions']);
  }
}
